export default function TopicsSection() {
  const topics = [
    { id: 1, name: '玄幻修仙', count: '2.8万', icon: 'ri-sword-line' },
    { id: 2, name: '热血战斗', count: '2.1万', icon: 'ri-fire-line' },
    { id: 3, name: '搞笑日常', count: '1.6万', icon: 'ri-emotion-laugh-line' },
    { id: 4, name: '科幻未来', count: '1.3万', icon: 'ri-rocket-line' },
    { id: 5, name: '恋爱甜宠', count: '1.2万', icon: 'ri-heart-line' },
    { id: 6, name: '武侠江湖', count: '9800', icon: 'ri-knife-line' },
    { id: 7, name: '悬疑推理', count: '7500', icon: 'ri-search-eye-line' },
    { id: 8, name: '末日废土', count: '6200', icon: 'ri-ghost-line' },
    { id: 9, name: '古风国韵', count: '5400', icon: 'ri-landscape-line' },
    { id: 10, name: '穿越异界', count: '4800', icon: 'ri-door-open-line' },
    { id: 11, name: '治愈温情', count: '4100', icon: 'ri-sun-line' },
  ];

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            探索51动漫社区最受欢迎的动漫话题与分类标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group inline-flex items-center gap-2.5 px-5 py-3 bg-background-50 rounded-full border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${topic.icon} text-sm`}></i>
              </div>
              <span className="font-heading text-sm text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}